import { connect } from 'react-redux';
import mapDispatchToProps from './mapDispatchToProps';
import mapStateToProps from './mapStateToProps';
import NextAvailabilityView from './component';

export default connect(mapStateToProps, mapDispatchToProps)(NextAvailabilityView);
